import { render, staticRenderFns } from "./ParamTabPane.vue?vue&type=template&id=372813fe&scoped=true"
import script from "./ParamTabPane.vue?vue&type=script&lang=js"
export * from "./ParamTabPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372813fe",
  null
  
)

export default component.exports